import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// web/js/path-breadcrumb/PathBreadcrumb.tsx
//
// Folder-path breadcrumb for a file. Renders link-rooted, department-rooted,
// or project-rooted breadcrumbs depending on whether the file is being viewed
// via a shared link, inside a department folder, or from the top-level project
// files list.
//
// Extracted from player-columns/PlayerColumn.tsx so the breadcrumb can be
// reused independently of the multi-column player tree.
import React from 'react';
/**
 * Folder-path breadcrumb. Renders link-rooted, department-rooted, or
 * project-rooted breadcrumbs depending on whether the view is via a shared
 * link, a department folder, or the top-level project files list.
 */
export function PathBreadcrumb({ data, linkId, projectId }) {
    const fileId = data.id;
    const items = [];
    if (linkId) {
        items.push(_jsx("a", { href: `files?link=${linkId}&show=${fileId}`, children: _jsxs("li", { children: [_jsx("img", { className: "file-path-icon", src: "img/Folder.svg", alt: "" }), data.link?.link_name ? data.link.link_name : 'Files'] }) }, "root"));
        if (data.link?.link_relative_path && data.link?.link_relative_path !== '/') {
            const components = data.link.link_relative_path.split('/').filter(Boolean);
            let tempPath = '';
            components.forEach((component, i) => {
                tempPath += '/' + component;
                items.push(_jsx("a", { href: `files?link=${linkId}&folder=${encodeURIComponent(tempPath)}&show=${fileId}`, children: _jsxs("li", { children: [_jsx("img", { className: "file-path-icon", src: "img/Folder.svg", alt: "" }), component] }) }, `p-${i}`));
            });
        }
    }
    else {
        items.push(_jsx("a", { href: `files?project=${projectId}&show=${fileId}`, children: _jsxs("li", { children: [_jsx("img", { className: "file-path-icon", src: "img/Folder.svg", alt: "" }), "Files"] }) }, "root"));
        if (data.department_id > -1 && data.department_name) {
            items.push(_jsx("a", { href: `files?dept=${data.department_id}&project=${projectId}&show=${fileId}`, children: _jsxs("li", { children: [_jsx("img", { className: "file-path-icon", src: "img/Dept_Folder.svg", alt: "" }), data.department_name] }) }, "dept"));
        }
        if (data.path && data.path !== '/') {
            const components = data.path.split('/').filter(Boolean);
            let tempPath = '';
            components.forEach((component, i) => {
                tempPath += '/' + component;
                items.push(_jsx("a", { href: `files?dept=${data.department_id}&folder=${encodeURIComponent(tempPath)}&project=${projectId}&show=${fileId}`, children: _jsxs("li", { children: [_jsx("img", { className: "file-path-icon", src: "img/Folder.svg", alt: "" }), component] }) }, `p-${i}`));
            });
        }
    }
    return (_jsx("ul", { className: "file-path-selector", children: items }));
}
export default PathBreadcrumb;
